import { useCallback , useState} from "react";
import API from "../apis";
import decode from 'jwt-decode';
import moment from 'moment';

export function useValidate() {
  const [validating, setValidating] = useState<boolean>(false);
  const onValidateEmail = useCallback(
    async (companyId: string, vendorIds: Array<string>, email: string) => {
      setValidating(true);
      try {
        const data = {
          companyId: companyId,
          vendors: vendorIds,
          emailAddress: email,
        };
        const response = await API.post(`Procore/ValidateEmailAddress`, data);
        setValidating(false);

        return response.data;
      } catch (e) {
        console.log(e);
        setValidating(false);

        return false;
      }
    },
    []
  );

  return {
    onValidateEmail,
    validating
  };
}

export function ValidateToken(history: any, isNavigateToSidepanel: boolean = false) {
 
  let isValidToken = true;
  const token = sessionStorage.getItem("token");

  let isTokenValid = true
  if (token) {
    const tokenData: any = decode(token);
    isTokenValid = moment.unix(tokenData.exp).isSameOrAfter(new Date());
  }

  if(!isTokenValid) {
    sessionStorage.removeItem("token");
  }

  if (!token || !isTokenValid) {
    isValidToken = false;
    let projectId = new URLSearchParams(window.location.search).get(
      "ProjectID"
    );
    let companyId = new URLSearchParams(window.location.search).get(
      "CompanyID"
    );

    if(isNavigateToSidepanel){
      history.push("/login", {
        projectId: projectId,
        companyId: companyId,
        navigateURL: "sidepanel",
        isSidePanel: true,
      });
    }else{
      history.push("/login", {
        projectId: projectId,
        companyId: companyId,
      });
    }
  }
  return isValidToken
}
